module.exports = __webpack_public_path__ + "img/MRV_818b8b8.webp";